import {
  CHANNEL_KINDS,
  CHANNEL_SUBCATEGORIES,
  ChannelStatus
} from '@/models/channels'
import { UserRole } from '@/modules/user/constants/user.constant' //TODO: Add import to index when pass to service
import { getMessageFormatted } from '@/store/pillars/channel/message/transformers'

const ALL_ADMINISTRATIVE = 'allAdministrative'
const ALL_SCREENING = 'allScreening'

export const getMessages = docs => {
  const lastMessages = []

  docs.forEach(doc => {
    const message = doc.data()

    lastMessages.push(...getMessageFormatted(message))
  })

  return lastMessages
}

const getCustomTag = user => {
  let customTagAll = []
  const userRole = user.role
  const userIsOnCall = user.isOnCall

  if (userRole.includes('NAVIGATOR')) customTagAll = [ALL_ADMINISTRATIVE]
  else if (
    userRole === UserRole.SCREENING_NURSE ||
    userRole.includes('DIGITAL_CARE') ||
    userIsOnCall
  )
    customTagAll = [ALL_SCREENING]

  return customTagAll
}

const getLongitudinalChats = user => {
  const userRole = user.role
  const userIsOnCall = user.isOnCall
  return userRole.includes('HEALTHCARE_TEAM_NURSE_REFERENCE') && !userIsOnCall
}

export const mountChatDrawerQuery = (user, firestoreSort) => {
  const customTagAll = getCustomTag(user)
  const userId = user.id

  const query = {
    filters: [
      { field: 'kind', condition: '==', value: CHANNEL_KINDS.CHAT },
      { field: 'status', condition: '==', value: ChannelStatus.ACTIVE },
      { field: 'staff', condition: '==', value: {} },
      {
        field: 'routingTo',
        condition: 'array-contains-any',
        value: [userId].concat(customTagAll)
      },
      { field: 'inactiveAt', condition: '==', value: null }
    ],
    orderBy: []
  }

  if (firestoreSort) {
    firestoreSort.forEach(sort => {
      if (sort.field !== 'totalUnreadMessages')
        query.orderBy.push({ field: sort.field, sort: sort.direction })
    })
  }

  if (getLongitudinalChats(user))
    query.filters.push({
      field: 'subCategory',
      condition: '==',
      value: CHANNEL_SUBCATEGORIES.LONGITUDINAL
    })

  return query
}

export const mountChannelDrawerQuery = (
  currentFilters,
  kind,
  status,
  starred,
  privateUnreadMentions,
  firestoreSort,
  currentPage
) => {
  const filters = [
    { field: 'kind', condition: '==', value: kind },
    { field: 'status', condition: '==', value: status }
  ]
  const orderBy = []
  if (currentFilters.tags?.length) {
    filters.push({
      field: 'tags',
      condition: 'array-contains-any',
      value: currentFilters.tags
    })
  }

  if (currentFilters.status?.length) {
    currentFilters.status.forEach(status => {
      status.filters.forEach(filter => {
        filters.push({
          field: filter.field,
          condition: filter.operation,
          value: filter.value
        })
      })
    })
  }

  // starred and privateUnreadMentions tab doesn't have
  // a filter by channelPersonId and they can't be combined
  if (starred) {
    filters.push({
      field: 'starred',
      condition: '==',
      value: starred
    })
  } else if (privateUnreadMentions) {
    filters.push({
      field: 'privateUnreadMentions',
      condition: '>',
      value: 0
    })
    orderBy.push({ field: 'privateUnreadMentions', sort: 'desc' })
  } else if (currentFilters.channelPersonId) {
    filters.push({
      field: 'channelPersonId',
      condition: '==',
      value: currentFilters.channelPersonId
    })
  }

  orderBy.push({ field: 'highlight', sort: 'desc' })

  if (firestoreSort) {
    firestoreSort.forEach(sort => {
      orderBy.push({ field: sort.field, sort: sort.direction })
    })
  }

  const limit = currentPage * 10

  const query = {
    filters,
    orderBy,
    limit
  }
  return query
}

export const mapDocs = docs =>
  docs?.map(doc => {
    const channel = doc.data ? doc.data() : doc
    const staffs = { ...channel.staff, ...channel.staffHistory }
    const staffArray = Object.values(staffs)

    return {
      ...channel,
      id: doc.id,
      staffs,
      staffArray
    }
  })
